import {
  SELECTED_OCPLC_KMAT,
  MODEL_AVAILABILITY,
  REGION_DROPDOWN,
  BUSINESS_MODEL,
  COUNTRY_LIST,
  FILTER_OCPLC_EDIT_DASHBOARD,
  LOCK_STATUS_DASHBOARD,
  FILTER_BY_STATUS,
  TOF_AUDIT_TRAIL,
  GET_PRODUCT_LINE,
  UPDATE_MODEL_AVAILABILITY,
  CREATE_EXISTING_AVAILABILITY,
  DELETE_MODEL_AVAILABILITY,
  DATA_TRANSPORT_AND_COMPLETE,
  CATEGORY_FILTER,
  MATERIAL_AVAILABILITY_TABLE,
  DELETE_MATERIAL_AVAILABILITY,
  CREATE_AVAILABILITY,
  UPDATE_MATERIAL_AVAILABILITY,
  UPDATE_SERVICE_AVAILABILITY,
  UPDATE_DEFAULT_LOCALIZATION,
  FACTORY_SERVICES_TABLE,
  GET_OCPLC_CHOICES,
  DELETE_SERVICE,
  PARAMETERS_TABLE,
  LOCALIZATION_DEFAULT_TABLE,
  LOCALIZATION_AVAILABILITY_TABLE,
  PRODUCT_GROUP_DROPDOWN,
  FILTER_OCPLC_KMAT_FOR_PG,
  UPLOAD_LAND_D_FILE,
  UPDATE_AVAILABILITY_LOCALIZATION,
  GET_DEFAULT_FEATURE_DROPDOWN,
  DELETE_AVIALABLE_LOCALIZATION,
  DELETE_DEFAULT_LOCALIZATION,
  TOF_PROGRAM_MANAGEMENT_TABLE,
  GET_DEFAULT_FEATURE_VALUE_DROPDOWN,
  CLEAR_OCPLC_DASHBOARD_FILTERS,
  CLEAR_OCPLC_FILTERS,
  GET_PARAMETERS_DROPDOWN,
  DELETE_TOF_PROGRAM_MANAGEMENT,
  UPDATE_TOF_PROGRAM_MANAGEMENT,
  LOCALIZATION_CHOICE_ID_TABLE,
  LOCALIZATION_MAPPING_TABLE,
  OCPLC_CONFIGURATION_TABLE,
  DELETE_LOC_CHOICEID,
  DELETE_LOC_MAPPING,
  MATERIAL_AVAILABILITY,
  FACTORY_SERVICES,
  DEFAULT_LOC,
  TOF_PROGRAM_MANAGEMENT,
  LOC_AVAILABILITY,
  LOC_MAPPING,
  LOC_CHOICE_ID,
  GET_LOCALIZATION_CHOICE_KEY,
  UPDATE_LOC_CHOICEID,
  GET_LOCALIZATION_CHOICE_NAME,
  GET_LOCALIZATION_CHOICE_VALUE,
  GET_PARAMETERS_LOCALIZATION_DROPDOWN,
  UPDATE_LOC_MAPPING,
  LOAD_COUNT_DT,
  GET_REGIONAL_CHECKBOXES,
  FILTERED_BY_LOCK_STATUS,
  RELEASELOCK,
  BULK_DOWNLOAD_UPLOAD_FILE
} from "constants/ocplcConstants";
import { applyFilters } from "pages/Utils/FilterUtil";

const initOcplcDashboard = {
    filters: {},
    filtersEdit : {},
    filteredOcplcData: [],
    filteredModelData: [],
    filteredFactoryData: [],
    filteredMaterialData: [],
    filteredTOFPMData: [],
    filteredLocalizationMappingData: [],
    filteredLocalizationChoiceIdData: [],
    filteredOcplcConfigurationData: [],
    filteredLocalizationAvailabilityData: [],
    filteredLocalizationDefaultData: [],
    isLoading: true,
    tableData: [],
    modelAvailabilityData: [],
    materialAvailabilityData: [],
    factoryServicesData: [],
    parametersData: [],
    tofProgramManagementData: [],
    localizationMappingData: [],
    localizationChoiceIdData: [],
    ocplcConfigurationData: [],
    localizationDefaultData: [],
    localizationAvailabilityData: [],
    countryListData: [],
    defaultFeatureDropdown: [],
    localizationChoice: [],
    localizationChoiceName: [],
    localizationChoiceValue: [],
    localizationMapping: [],
    defaultFeatureValueDropdown: [],
    parametersDropdown: [],
    businessModels: [],
    regionDropdown: [],
    filterKmats: [],
    lockStatus: {},
    modelAuditTOFTrial: [],
    productLine: [],
    ocplcChoice:[],
    dataTransport: [],
    filteredStatus:[],
    isMaterial: false,
    isService: false,
    isDefaultLOC: false,
    isLOCAvailability: false,
    isTOFPM: false,
    isLocChoiceID: false,
    isLocMapping: false,
    downloadModelAvailabilityData: [],
    loadCount: 0,
    productGroupDropdown: [],
    uploadFileData: {},
    regionalCheckboxes: {},
};

export const ocplcReducer = (state = initOcplcDashboard, { type, payload }) => {
    switch (type) {
        case "REFRESH_OCPLC": {
            const newData = payload || initOcplcDashboard;
            const newState = {
                ...newData,
                isLoading: false,
                filters: state.filters,
                filtersEdit: state.filtersEdit,
                tableData: state.tableData,// Preserve existing tableData
                loadCount: state.loadCount // Preserve existing loadCount
            };

            const itemsToFilter = newState.ocplcProductModels;
            const filteredOcplcData = applyFilters(Object.values(state.filters), itemsToFilter);
            const filteredModelData = applyFilters(Object.values(state.filtersEdit), newData.modelAvailabilityData);
            const filteredMaterialData = applyFilters(Object.values(state.filtersEdit), newData.materialAvailabilityData);
            const filteredFactoryData = applyFilters(Object.values(state.filtersEdit), newData.factoryServicesData);
            const filteredParametersData = applyFilters(Object.values(state.filtersEdit), newData.parametersData);
            const filteredTOFPMData = applyFilters(Object.values(state.filtersEdit), newData.tofProgramManagementData);
            const filteredLocalizationMappingData = applyFilters(Object.values(state.filtersEdit), newData.localizationMappingData);
            const filteredLocalizationChoiceIdData = applyFilters(Object.values(state.filtersEdit), newData.localizationChoiceIdData);
            const filteredOcplcConfigurationData = applyFilters(Object.values(state.filtersEdit), newData.ocplcConfigurationData);
            const filteredLocalizationDefaultData = applyFilters(Object.values(state.filtersEdit), newData.localizationDefaultData);
            const filteredLocalizationAvailabilityData = applyFilters(Object.values(state.filtersEdit), newData.localizationAvailabilityData);

            return {
                ...newState,
                filteredOcplcData,
                filteredModelData,
                filteredMaterialData,
                filteredFactoryData,
                filteredParametersData,
                filteredTOFPMData,
                filteredLocalizationMappingData,
                filteredLocalizationChoiceIdData,
                filteredOcplcConfigurationData,
                filteredLocalizationDefaultData,
                filteredLocalizationAvailabilityData,
            };
        }
        case CLEAR_OCPLC_DASHBOARD_FILTERS: {
            return {
                ...state,
                filters: {},
                filtersEdit:{},
                filteredOcplcData: state.ocplcProductModels,
            };
        }
        case CLEAR_OCPLC_FILTERS: {
            return {
                ...state,
                filtersEdit: {},
                filteredModelData: state.modelAvailabilityData,
                filteredMaterialData: state.materialAvailabilityData,
                filteredFactoryData: state.factoryServicesData,
                filteredParametersData: state.parametersData,
                filteredTOFPMData: state.tofProgramManagementData,
                filteredLocalizationMappingData: state.localizationMappingData,
                filteredLocalizationChoiceIdData: state.localizationChoiceIdData,
                filteredOcplcConfigurationData: state.ocplcConfigurationData,
                filteredLocalizationDefaultData: state.localizationDefaultData,
                filteredLocalizationAvailabilityData: state.localizationAvailabilityData,
                filteredStatus: []
            };
        }
        case "FILTER_OCPLC": {
            const { name, searchText, matchFields, type: filterType } = payload;

            const filters = {
                ...state.filters,
                [name]: {
                    value: searchText,
                    type: filterType,
                    matchFields
                }
            };
            const filteredOcplcData = applyFilters(Object.values(filters), state.ocplcProductModels);
            return {
                ...state,
                filters,
                filteredOcplcData
            };
        }
        case "OCPLC_TABLE_DATA": {
            return {
                ...state,
                tableData: payload,
            };
        }
        case FILTERED_BY_LOCK_STATUS: {
            let filteredMaterialData = applyFilters(Object.values(state.filtersEdit), state.materialAvailabilityData);
            filteredMaterialData = filteredMaterialData.filter(item => item.logicalLock !== 0);
            return {
                ...state,
                filteredMaterialData,
            };
        }
        case FILTER_OCPLC_EDIT_DASHBOARD: {
            const { name, searchText, matchFields, type } = payload;

            const updatedFilters = {
                ...state.filtersEdit,
                [name]: {
                    value: searchText,
                    type,
                    matchFields
                }
            };
            const filteredModelData = applyFilters(Object.values(updatedFilters), state.modelAvailabilityData);
            const filteredMaterialData = applyFilters(Object.values(updatedFilters), state.materialAvailabilityData);
            const filteredFactoryData = applyFilters(Object.values(updatedFilters), state.factoryServicesData);
            const filteredParametersData = applyFilters(Object.values(updatedFilters), state.parametersData);
            const filteredTOFPMData = applyFilters(Object.values(updatedFilters), state.tofProgramManagementData);
            const filteredLocalizationMappingData = applyFilters(Object.values(updatedFilters), state.localizationMappingData);
            const filteredLocalizationChoiceIdData = applyFilters(Object.values(updatedFilters), state.localizationChoiceIdData);
            const filteredOcplcConfigurationData = applyFilters(Object.values(updatedFilters), state.ocplcConfigurationData);
            const filteredLocalizationDefaultData = applyFilters(Object.values(updatedFilters), state.localizationDefaultData);
            const filteredLocalizationAvailabilityData = applyFilters(Object.values(updatedFilters), state.localizationAvailabilityData);
            return {
                ...state,
                filtersEdit: updatedFilters,
                filteredModelData,
                filteredMaterialData,
                filteredFactoryData,
                filteredParametersData,
                filteredTOFPMData,
                filteredLocalizationMappingData,
                filteredLocalizationChoiceIdData,
                filteredOcplcConfigurationData,
                filteredLocalizationDefaultData,
                filteredLocalizationAvailabilityData
            };
        }

      case FILTER_BY_STATUS: {
    const { statusList, selectedTable } = payload;

    const isMaterial = selectedTable === MATERIAL_AVAILABILITY;
    const isService = selectedTable === FACTORY_SERVICES;
    const isDefaultLOC = selectedTable === DEFAULT_LOC;
    const isLOCAvailability = selectedTable === LOC_AVAILABILITY;
    const isTOFProgramManagement = selectedTable === TOF_PROGRAM_MANAGEMENT;
    const isLocalizationMapping = selectedTable === LOC_MAPPING;
    const isLocalizationChoiceId = selectedTable === LOC_CHOICE_ID;

    const tableData = isMaterial ? state.materialAvailabilityData
        : isService ? state.factoryServicesData
        : isDefaultLOC ? state.localizationDefaultData
        : isLOCAvailability ? state.localizationAvailabilityData
        : isTOFProgramManagement ? state.tofProgramManagementData
        : isLocalizationMapping ? state.localizationMappingData
        : isLocalizationChoiceId ? state.localizationChoiceIdData
        : state.modelAvailabilityData;

    let filteredData = applyFilters(Object.values(state.filtersEdit), tableData);
    if (statusList && statusList.length > 0) {
        filteredData = filteredData.filter(item => statusList.includes(item.status));
    }

    return {
        ...state,
        filteredStatus: statusList,
        filteredMaterialData: isMaterial ? filteredData : [],
        filteredModelData: (!isMaterial && !isService && !isDefaultLOC && !isLOCAvailability && !isTOFProgramManagement) ? filteredData : [],
        filteredFactoryData: isService ? filteredData : [],
        filteredTOFPMData: isTOFProgramManagement ? filteredData : [],
        filteredLocalizationMappingData: isLocalizationMapping ? filteredData : [],
        filteredLocalizationChoiceIdData: isLocalizationChoiceId ? filteredData : [],
        filteredLocalizationDefaultData: isDefaultLOC ? filteredData : [],
        filteredLocalizationAvailabilityData: isLOCAvailability ? filteredData : [],
        isMaterial,
        isService,
        isDefaultLOC,
        isLOCAvailability,
        isTOFProgramManagement
    };
}

        case MODEL_AVAILABILITY: {
            const { data, isLoading } = payload || {};
            let filteredModelData = applyFilters(Object.values(state.filtersEdit), data);
            if (state.filteredStatus?.length > 0) {
                filteredModelData = filteredModelData.filter(item => state.filteredStatus.includes(item.status));
            }
            return {
                ...state,
                modelAvailabilityData: data,
                filteredModelData,
                isLoading: isLoading,
                isMaterial: false,
                isService: false,
                isDefaultLOC: false,
                isLOCAvailability: false,
                isTOFPM: false,
                isLocChoiceID:  false,
                isLocMapping: false
            };
        }

        case MATERIAL_AVAILABILITY_TABLE: {
            const { data, isLoading } = payload || {};
            let filteredMaterialData = applyFilters(Object.values(state.filtersEdit), data);
            if (state.filteredStatus?.length > 0) {
                filteredMaterialData = filteredMaterialData.filter(item => state.filteredStatus.includes(item.status));
            }
            return {
                ...state,
                materialAvailabilityData: data,
                filteredMaterialData,
                isLoading: isLoading,
                isMaterial: true,
                isService: false,
                isDefaultLOC: false,
                isLOCAvailability: false,
                isTOFPM: false,
                isLocChoiceID: false,
                isLocMapping: false
            };
        }
        case FACTORY_SERVICES_TABLE: {
            const { data, isLoading } = payload || {};
            let filteredFactoryData = applyFilters(Object.values(state.filtersEdit), data);
            if (state.filteredStatus?.length > 0) {
                filteredFactoryData = filteredFactoryData.filter(item => state.filteredStatus.includes(item.status));
            }
            return {
                ...state,
                factoryServicesData: data,
                filteredFactoryData,
                isLoading: isLoading,
                isMaterial: false,
                isService: true,
                isDefaultLOC: false,
                isLOCAvailability: false,
                isTOFPM: false,
                isLocChoiceID: false,
                isLocMapping: false
            };
        }

        case TOF_PROGRAM_MANAGEMENT_TABLE: {
            const { data, isLoading } = payload || {};
            let filteredTOFPMData = applyFilters(Object.values(state.filtersEdit), data);
            if (state.filteredStatus?.length > 0) {
                filteredTOFPMData = filteredTOFPMData.filter(item => state.filteredStatus.includes(item.status));
            }
            return {
                ...state,
                tofProgramManagementData: data,
                filteredTOFPMData,
                isLoading: isLoading,
                isMaterial: false,
                isService: false,
                isDefaultLOC: false,
                isLOCAvailability: false,
                isTOFPM: true,
                isLocChoiceID: false,
                isLocMapping: false
            };
        }

        case LOCALIZATION_MAPPING_TABLE: {
            const { data, isLoading } = payload || {};
            let filteredLocalizationMappingData = applyFilters(Object.values(state.filtersEdit), data);
            if (state.filteredStatus?.length > 0) {
                filteredLocalizationMappingData = filteredLocalizationMappingData.filter(item => state.filteredStatus.includes(item.status));
            }
            return {
                ...state,
                localizationMappingData: data,
                filteredLocalizationMappingData,
                isLoading: isLoading,
                isMaterial: false,
                isService: false,
                isDefaultLOC: false,
                isLOCAvailability: false,
                isTOFPM: false,
                isLocChoiceID: false,
                isLocMapping: true
            };
        }
        case LOCALIZATION_CHOICE_ID_TABLE: {
            const { data, isLoading } = payload || {};
            let filteredLocalizationChoiceIdData = applyFilters(Object.values(state.filtersEdit), data);
            if (state.filteredStatus?.length > 0) {
                filteredLocalizationChoiceIdData = filteredLocalizationChoiceIdData.filter(item => state.filteredStatus.includes(item.status));
            }
            return {
                ...state,
                localizationChoiceIdData: data,
                filteredLocalizationChoiceIdData,
                isLoading: isLoading,
                isMaterial: false,
                isService: false,
                isDefaultLOC: false,
                isLOCAvailability: false,
                isTOFPM: false,
                isLocChoiceID: true,
                isLocMapping: false
            };
        }
        case OCPLC_CONFIGURATION_TABLE: {
            const { data, isLoading } = payload || {};
            let filteredOcplcConfigurationData = applyFilters(Object.values(state.filtersEdit), data);
            return {
                ...state,
                ocplcConfigurationData: data,
                filteredOcplcConfigurationData,
                isLoading: isLoading,
                isMaterial: false,
                isService: false,
                isDefaultLOC: false,
                isLOCAvailability: false,
                isTOFPM: false,
                isLocChoiceID: false,
                isLocMapping: false
            };
        }

        case LOCALIZATION_DEFAULT_TABLE: {
            const { data, isLoading } = payload || {};
            let filteredLocalizationDefaultData = applyFilters(Object.values(state.filtersEdit), data);
            return {
                ...state,
                localizationDefaultData: data,
                filteredLocalizationDefaultData,
                isLoading: isLoading,
                isMaterial: false,
                isService: false,
                isDefaultLOC: true,
                isLOCAvailability: false,
                isTOFPM: false,
                isLocChoiceID: false,
                isLocMapping: false
            };
        }
        case LOCALIZATION_AVAILABILITY_TABLE: {
            const { data, isLoading } = payload || {}; 
            let filteredLocalizationAvailabilityData = applyFilters(Object.values(state.filtersEdit), data);
            return {
                ...state,
                localizationAvailabilityData: data,
                filteredLocalizationAvailabilityData,
                isLoading: isLoading,
                isMaterial: false,
                isService: false,
                isDefaultLOC: false,
                isLOCAvailability: true,
                isTOFPM: false,
                isLocChoiceID: false,
                isLocMapping: false
            }
        }
        case UPDATE_MODEL_AVAILABILITY:{
            const updatedData = payload;
            const filteredModelData = state.filteredModelData.map(item => {
                if (item.pkId === updatedData.pkId) {
                    return payload ;
                }
                return item;
            });
            return {
                ...state,
                filteredModelData         
           }

        };

        case UPDATE_MATERIAL_AVAILABILITY: {
            const updatedData = payload;
            const filteredMaterialData = state.filteredMaterialData.map(item => {
                if (item.pkId === updatedData.pkId) {
                    return payload;
                }
                return item;
            });
            return {
                ...state,
                filteredMaterialData
            };
        };

        case UPDATE_SERVICE_AVAILABILITY: {
            const updatedData = payload;
            const filteredFactoryData = state.filteredFactoryData.map(item => {
                if (item.pkId === updatedData.pkId) {
                    return payload;
                }
                return item;
            });
            return {
                ...state,
                filteredFactoryData
            };
        }

        case UPDATE_DEFAULT_LOCALIZATION: {
            const updatedData = payload;
            const filteredLocalizationDefaultData = state.filteredLocalizationDefaultData.map(item => {
                if (item.pkId === updatedData.pkId) {
                    return payload;
                }
                return item;
            });
            return {
                ...state,
                filteredLocalizationDefaultData
            };
        }

        case UPDATE_AVAILABILITY_LOCALIZATION: {
            const updatedData = payload;
            const filteredLocalizationAvailabilityData = state.filteredLocalizationAvailabilityData.map(item => {
                if (item.pkId === updatedData.pkId) {
                    return payload;
                }
                return item;
            });
            return {
                ...state,
                filteredLocalizationAvailabilityData
            };
        }  
        
        case UPDATE_TOF_PROGRAM_MANAGEMENT: {
            const updatedData = payload;
            const filteredTOFPMData = state.filteredTOFPMData.map(item => {
                if (item.pkId === updatedData.pkId) {
                    return payload;
                }
                return item;
            });
            return {
                ...state,
                filteredTOFPMData
            };
        }

        case UPDATE_LOC_CHOICEID:{
            const updatedData = payload;
            const filteredLocalizationChoiceIdData = state.filteredLocalizationChoiceIdData.map(item => {
                if (item.pkId === updatedData.pkId) {
                    return payload ;
                }
                return item;
            });
            return {
                ...state,
                filteredLocalizationChoiceIdData         
           }
        }

        case UPDATE_LOC_MAPPING:{
            const updatedData = payload;
            const filteredLocalizationMappingData = state.filteredLocalizationMappingData.map(item => {
                if (item.pkId === updatedData.pkId) {
                    return payload ;
                }
                return item;
            }
            );
            return {
                ...state,
                filteredLocalizationMappingData         
           }
        }

        case CREATE_EXISTING_AVAILABILITY: {
            const dataKey = state.isMaterial ? 'materialAvailabilityData' : state.isService ? 'factoryServicesData' : state.isDefaultLOC ? 'localizationDefaultData' : state.isLOCAvailability ? 'localizationAvailabilityData' : state.isTOFPM ? 'tofProgramManagementData' :state.isLocChoiceID ? 'localizationChoiceIdData' : state.isLocMapping ? 'localizationMappingData' : 'modelAvailabilityData';
            const filteredKey = state.isMaterial ? 'filteredMaterialData' : state.isService ? 'filteredFactoryData' : state.isDefaultLOC ? 'filteredLocalizationDefaultData' : state.isLOCAvailability ? 'filteredLocalizationAvailabilityData' : state.isTOFPM ? 'filteredTOFPMData' : state.isLocChoiceID ? 'filteredLocalizationChoiceIdData' : state.isLocMapping ? 'filteredLocalizationMappingData' : 'filteredModelData';

            const updatedData = payload;
            const updateData = (data) => {
                const filteredData = data.filter(item => item.pkId !== updatedData.pkId);
                return [updatedData, ...filteredData];
            };
        
            return {
                ...state,
                [dataKey]: payload?.pkId !== null? updateData(state[dataKey]) : state[dataKey],
                [filteredKey]: payload?.pkId !== null? updateData(state[filteredKey]) : state[filteredKey],
                isLoading:payload?.isLoading || false
            };
        }

        case GET_DEFAULT_FEATURE_DROPDOWN: {
            return {
                ...state,
                defaultFeatureDropdown: payload || [],
            };
        }

        case GET_LOCALIZATION_CHOICE_KEY: {
            return {
                ...state,
                localizationChoice: payload || [],
            };
        }

        case GET_LOCALIZATION_CHOICE_NAME: {
            return {
                ...state,
                localizationChoiceName: payload || [],
            };
        }

        case GET_LOCALIZATION_CHOICE_VALUE: {
            return {
                ...state,
                localizationChoiceValue: payload || [],
            };
        }

        case GET_PARAMETERS_LOCALIZATION_DROPDOWN:{
            return {
                ...state,
                localizationMapping: payload || [],
            };
        }

        case GET_DEFAULT_FEATURE_VALUE_DROPDOWN: {
            return {
                ...state,
                defaultFeatureValueDropdown: payload || [],
            };
        }

        case GET_PARAMETERS_DROPDOWN: {
            return {
                ...state,
                parametersDropdown: payload || [],
            };
        }

        case COUNTRY_LIST: {
            return {
                ...state,
                countryListData: payload || [],
            };
        }
        case BUSINESS_MODEL: {
            return {
                ...state,
                businessModels: payload || [],
            };
        }
        case "FILTER_KMAT": {
            const kmatMap = payload.reduce((acc, item) => { acc[item.kmatId] = item;
                return acc;
            }, {});
            return {
                ...state,
                filterKmats: kmatMap
            };
        } 
        case CATEGORY_FILTER: {
            return {
                ...state,
                categoryFilter: payload
            };
        }
        case REGION_DROPDOWN: {
            return {
                ...state,
                regionDropdown: payload || [],
            };
        }
        case LOCK_STATUS_DASHBOARD: {
            return {
                ...state,
                lockStatus: payload || {},
                parametersDropdown:[],
                ocplcChoice:[]
            };
        }
        case DELETE_MODEL_AVAILABILITY: {
            const { pkId, isLoading } = payload;
            const updatedModelAvailabilityData = pkId !== null ?  state.modelAvailabilityData.filter(item => item.pkId !== pkId) : state.modelAvailabilityData;
            const updatedFilteredModelData = pkId !== null ? state.filteredModelData.filter(item => item.pkId !== pkId) : state.filteredModelData;

            return {
                ...state,
                modelAvailabilityData: updatedModelAvailabilityData,
                filteredModelData: updatedFilteredModelData,
                isLoading: isLoading || false
            };
        }
        case DELETE_MATERIAL_AVAILABILITY: {
            const { pkId, isLoading } = payload;
            const updatedMaterialAvailabilityData = pkId !== null ? state.materialAvailabilityData.filter(item => item.pkId !== pkId) : state.materialAvailabilityData;
            const updatedFilteredMaterialData = pkId !== null ? state.filteredMaterialData.filter(item => item.pkId !== pkId) : state.filteredMaterialData;

            return {
                ...state,
                materialAvailabilityData: updatedMaterialAvailabilityData,
                filteredMaterialData: updatedFilteredMaterialData,
                isLoading: isLoading || false
            };
        }
        case DELETE_SERVICE : {
            const { pkId, isLoading } = payload;
            const updatedFactoryServicesData = pkId !== null ? state.factoryServicesData.filter(item => item.pkId !== pkId) : state.factoryServicesData;
            const updatedFilteredFactoryData = pkId !== null ? state.filteredFactoryData.filter(item => item.pkId !== pkId) : state.filteredFactoryData;
            return {
                ...state,
                factoryServicesData: updatedFactoryServicesData,
                filteredFactoryData: updatedFilteredFactoryData,
                isLoading: isLoading || false
            };

        }
        case DELETE_AVIALABLE_LOCALIZATION : {
            const { pkId, isLoading } = payload;
            const updatedLocalizationAvailityData = pkId !== null ? state.localizationAvailabilityData.filter(item => item.pkId !== pkId) : state.localizationAvailabilityData;
            const updatedFilteredLocalizationAvailityData = pkId !== null ? state.filteredLocalizationAvailabilityData.filter(item => item.pkId !== pkId) : state.filteredLocalizationAvailabilityData;
            return {
                ...state,
                localizationAvailabilityData: updatedLocalizationAvailityData,
                filteredLocalizationAvailabilityData: updatedFilteredLocalizationAvailityData,
                isLoading: isLoading || false
            };

        }
        case DELETE_DEFAULT_LOCALIZATION : {
            const { pkId, isLoading } = payload;
            const updatedDefaultLocalizationData = pkId !== null ? state.localizationDefaultData.filter(item => item.pkId !== pkId) : state.localizationDefaultData;
            const updatedFilteredDefaultLocalizationData = pkId !== null ? state.filteredLocalizationDefaultData.filter(item => item.pkId !== pkId) : state.filteredLocalizationDefaultData;
            return {
                ...state,
                localizationDefaultData: updatedDefaultLocalizationData,
                filteredLocalizationDefaultData: updatedFilteredDefaultLocalizationData,
                isLoading: isLoading || false
            };

        }
        case DELETE_TOF_PROGRAM_MANAGEMENT : {
            const { pkId, isLoading } = payload;
            const updatedTofProgramManagementData = pkId !== null ? state.tofProgramManagementData.filter(item => item.pkId !== pkId) : state.tofProgramManagementData;
            const updatedFilteredTOFPMData = pkId !== null ? state.filteredTOFPMData.filter(item => item.pkId !== pkId) : state.filteredTOFPMData;
            return {
                ...state,
                tofProgramManagementData: updatedTofProgramManagementData,
                filteredTOFPMData: updatedFilteredTOFPMData,
                isLoading: isLoading || false
            };

        }
        case DELETE_LOC_CHOICEID : {
            const { pkId, isLoading } = payload;
            const updatedLocalizationChoiceIdData = pkId !== null ? state.localizationChoiceIdData.filter(item => item.pkId !== pkId) : state.localizationChoiceIdData;
            const updatedFilteredLocalizationChoiceIdData = pkId !== null ?  state.filteredLocalizationChoiceIdData.filter(item => item.pkId !== pkId) : state.filteredLocalizationChoiceIdData;
            return {
                ...state,
                localizationChoiceIdData: updatedLocalizationChoiceIdData,
                filteredLocalizationChoiceIdData: updatedFilteredLocalizationChoiceIdData,
                isLoading: isLoading || false
            };

        }
        case DELETE_LOC_MAPPING : {
            const { pkId, isLoading } = payload;
            const updatedLocalizationMappingData = pkId !== null ? state.localizationMappingData.filter(item => item.pkId !== pkId) : state.localizationMappingData;
            const updatedFilteredLocalizationMappingData = pkId !== null ? state.filteredLocalizationMappingData.filter(item => item.pkId !== pkId) : state.filteredLocalizationMappingData;
            return {
                ...state,
                localizationMappingData: updatedLocalizationMappingData,
                filteredLocalizationMappingData: updatedFilteredLocalizationMappingData,
                isLoading: isLoading || false
            };

        }
        case TOF_AUDIT_TRAIL: {
            const {modelAuditTrial, isLoading}=payload
            return {
                ...state,
                modelAuditTOFTrial: modelAuditTrial,
                isLoading:isLoading || false
            };
        }
        case GET_PRODUCT_LINE: {
            return {
                ...state,
                productLine: payload
            };
        }

        case GET_OCPLC_CHOICES: {
            return {
                ...state,
                ocplcChoice: payload
            };
        }


        case CREATE_AVAILABILITY: {
            const dataKey = state.isMaterial ? 'materialAvailabilityData' : state.isService ? 'factoryServicesData' : state.isDefaultLOC ? 'localizationDefaultData' : state.isTOFPM ? 'tofProgramManagementData' : state.isLocChoiceID ? 'localizationChoiceIdData' : state.isLocMapping ? 'localizationMappingData' : 'modelAvailabilityData';
            const filteredKey = state.isMaterial ? 'filteredMaterialData' : state.isService ? 'filteredFactoryData' : state.isDefaultLOC ? 'filteredLocalizationDefaultData' : state.isTOFPM ? 'filteredTOFPMData' : state.isLocChoiceID ? 'filteredLocalizationChoiceIdData' : state.isLocMapping ? 'filteredLocalizationMappingData' : 'filteredModelData';
            return {
                ...state,
                [dataKey]: payload?.createAvailability !== null ? [payload?.createAvailability, ...state[dataKey]]:[...state[dataKey]],
                [filteredKey]: payload?.createAvailability !== null ? [payload?.createAvailability, ...state[filteredKey]]:[...state[filteredKey]],
                isLoading: payload?.isLoading || false
            };
        }
        case DATA_TRANSPORT_AND_COMPLETE: {
            return {
                ...state,
                dataTransport: payload?.dataTransport || state.dataTransport,
                isLoading: payload.isLoading || false 
            };
        }
        case LOAD_COUNT_DT: {
            return {
                ...state,
                loadCount: payload,
            };
        
        }
        case PRODUCT_GROUP_DROPDOWN: {
            return {
                ...state,
                productGroupDropdown: payload,
            };
        }
       
        case FILTER_OCPLC_KMAT_FOR_PG: {
            return {
                ...state,
                filterOcplcKmatForPG: payload
            };
        }
        case UPLOAD_LAND_D_FILE: {
            return {
                ...state,
                uploadFileData: payload?.isLoading ?{} : payload?.uploadFile,
                isLoading: payload?.isLoading || false
            };
        }
        case BULK_DOWNLOAD_UPLOAD_FILE: {
            return {
                ...state,
                isLoading: payload?.isLoading || false
            };
        }
        case GET_REGIONAL_CHECKBOXES: {
            return {
                ...state,
                regionalCheckboxes: payload || {},
                isLoading: payload?.isLoading || false
            };
        }
        case RELEASELOCK: {
            return{
                ...state,
                isLoading:payload?.isLoading || false
            }
        }
        default: return state;
    }
};